import { format, utcToZonedTime, toDate } from "date-fns-tz";
import { Data } from "../typescript/interfaces/context";
import { DataExportCSV, IndicationApprovalStatus } from "../typescript/interfaces/data";
import { IndicationApprovalStageType } from "../typescript/enums/data";

export const dateToStr = (dateStr: string, dateFormat: string): string => {
  const timeZone = "Europe/London";
  let utcDate;

  const timestamp = Date.parse(dateStr);
  if (isNaN(timestamp)) {
    const milliseconds = parseInt(dateStr, 10);
    utcDate = toDate(milliseconds);
  } else {
    const parsedISO = toDate(dateStr);
    utcDate = parsedISO;
  }

  const zonedDate = utcToZonedTime(utcDate, timeZone);
  return format(zonedDate, dateFormat, { timeZone });
};

const stagesExportColumn = (indications: IndicationApprovalStatus[]) => {
  const output = indications
    .map(({ stage, date }) => {
      const showDate = stage === IndicationApprovalStageType.CRL || stage === IndicationApprovalStageType.Pending;
      const formattedDate = showDate && date ? ` (${date})` : "";
      return `${stage}${formattedDate}`;
    })
    .join("; ");

  return output;
};

export const dataForExport = (rows: Data[]): DataExportCSV[] => {
  return rows.map((row) => ({
    brandName: row.brandName,
    genericName: row.genericName,
    brandCompanies: row.brandCompanies.map((company) => company.name).join("; ") || "",
    routesOfAdministration: row.routesOfAdministration.map((route) => route.name).join("; ") || "",
    mechanismsOfAction: row.mechanismsOfAction.map((mechanism) => mechanism.name).join("; ") || "",
    indications: row.indicationApprovalStatus.map((indication) => indication.indication).join("; ") || "",
    stages: stagesExportColumn(row.indicationApprovalStatus) || "",
    submissionTypes: row.submissionTypes.join("; ") || "",
    tags: row.tags.join("; ") || "",
    exclusivities: row.exclusivities.map((exclusivity) => exclusivity.name).join("; ") || "",
  }));
};

export const exportFileName = () => {
  const todaysDate = dateToStr(new Date().toISOString(), "MM/dd/yyyy");
  return `Clinical_Development_Pipeline_${todaysDate}.csv`;
};
